import App from '../index.js';

App.Bots = (function () {

    function initDataTable (el) {
        let options = {
            destroy: true,
            serverSide: true,
            processing: true,
            searching: true,
            deferRender: true,
            stateSave: false,
            pageLength: 25,
            lengthChange: false,
            language: {
                searchPlaceholder: "Search",
                search: "",
            },
            layout: {
                topStart: { div: { className: 'table-headline' } },
                topEnd: 'search',
                bottomStart: 'info',
                bottomEnd: 'paging',
            },
            initComplete: function () {
                let elDataTableWrapper = $(this).closest('.data-table-wrapper');
                elDataTableWrapper.find('.table-headline').html(elDataTableWrapper.find('.data-table-headline').html());
                elDataTableWrapper.find('[type="search"]').removeClass('form-control-sm').closest('label').addClass('form-group search-box').prepend('<i class="search-icon fas fa-search"></i>');
                elDataTableWrapper.find('.dt-search .form-group, .dt-search .search-box').wrapAll('<div class="form-row justify-content-end align-items-center text-end"></div>');

            },
            order: [[ 0, "desc" ]],
            ajax: {
                url: el.data('query-url'),
                type: "POST",
                data: function (d) {
                    d._token = $('meta[name="csrf-token"]').attr('content');
                }
            },
            columns: [
                {
                    data: 'name',
                    orderable: false,
                    className: 'datatable-date'
                },
                {
                    data: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'datatable-action'
                }
            ]
        };

        el.DataTable(options);
    }

    function deleteBot () {

        let name = $(this).data('name');
        let route = $(this).data('url');
        $('#deleteOrganizationBot form').attr('action', route);
        $('#deleteOrganizationBot .header-sub-text').html(`Are you sure you want to delete bot ${name}? <br/><br/>Type (<strong>${name}</strong>) to confirm.`);
    }

    function deleteSurvey () {
        let name = $(this).data('name');
        let route = $(this).data('url');
        $('#deleteOrganizationSurvey form').attr('action', route);
        $('#deleteOrganizationSurvey .header-sub-text').html(`Are you sure you want to delete survey ${name}? <br/><br/>Type (<strong>${name}</strong>) to confirm.`);
    }

    function duplicateSurvey () {
        let name = $(this).data('name');
        let route = $(this).data('url');
        $('#duplicateSurvey form').attr('action', route);
        $('#duplicateSurvey .header-sub-text').html(`Are you sure you want to duplicate Survey: ${name}?`);
    }

    function initSelectedTab () {
        const hash = window.location.hash
        if (hash) {
            $('#organization_bots_surveys_wrapper .nav-tabs .nav-link[href="' + hash + '"]')?.[0].click();
        }
    }

    function onClickedNavLink (  ) {
        const hash = $(this).attr('href');
        window.location.hash = hash;
    }

    return {
        init: function(){
            initDataTable($('#bots_table'));
            initSelectedTab();
            App.dataTableTypeDelay($('#bots_table_wrapper .dt-search input[type="search"]'));

            if($('#surveys_table')[0]) {
                initDataTable($('#surveys_table'));
                App.dataTableTypeDelay($('#surveys_table_wrapper .dt-search input[type="search"]'));
            }


            $('body').on('click', '.delete-organization-bot', deleteBot)
                .on('click', '.delete-organization-survey', deleteSurvey)
                .on('click', '.btn-duplicate-survey', duplicateSurvey)
                .on('click', '#organization_bots_surveys_wrapper .nav-tabs .nav-link', onClickedNavLink);


            $('#deleteUserBot').on('hide.bs.modal', function () {
                $('.header-sub-text').empty();
            });
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.show', App.Bots.init);
App.registerRoute('global-bots.index', App.Bots.init);

export default App.Bots;
